import React from 'react';
import { ListItem as ChakraListItem, ListItemProps as ChakraListItemProps } from '@chakra-ui/react';

export function ListItem(props: ChakraListItemProps) {
  return <ChakraListItem {...props} />;
}
